import type { NetworkData } from '@dynamic-labs-sdk/client';
import { TronWeb } from 'tronweb';

import { SUN_PER_TRX } from '../constants';

type FetchTronBalanceParams = {
  address: string;
  networkData: NetworkData;
};

export const fetchTronBalance = async ({
  address,
  networkData,
}: FetchTronBalanceParams): Promise<string | null> => {
  const tronWeb = new TronWeb({
    fullHost: networkData.rpcUrls.http[0],
  });

  const balanceInSun = await tronWeb.trx.getBalance(address);

  return (Number(balanceInSun) / SUN_PER_TRX).toString();
};
